import { GET, RAW_DELETE, RAW_POST, RAW_PUT } from "Common/api";
import { getJsonOrDefault } from "Common/api/functions";

const API_UNITS = "v1/talentmanagement/manager/team-available-units";
const API_TEAM = "v1/teams/";
const API_BASE = "v1/";
const API_PERMISSIONS = "v1/teams/rights";
const API_ADD_TEAM = "v1/team/";
const API_DELETE_TEAM = "v1/team";
const API_UPDATE_TEAM = "v1/teams";
const API_GET_USERS_TABLE_FIELDS = "v1/user/fields";

const ERROR_MESSAGE = "error";

export async function fetchTeams(unitId = 1) {
  let data = await GET(`v1/unit/${unitId}/teams`);
  return data;
}

export async function fetchResponsibleTeams(personalId) {
  let data = await GET(`v1/user/${personalId}/teams`);
  return data;
}

export async function fetchReadOnlyTeams() {
  const data = await GET(`v1/user/hr/teams`);
  return data;
}

export async function fetchCoworkerTeams(personalId) {
  let data = await GET(`v1/teams/coworker/${personalId}`);
  return data;
}

export async function fetchResponsibleUnits() {
  let data = await GET(`v1/talentmanagement/manager/dashboard/available-units`);
  return data;
}

export async function fetchReadOnlyUnits() {
  let data = await GET(`v1/talentmanagement/manager/dashboard/readonly-units`);
  return data;
}

export async function fetchCoworkerUnits(personalId) {
  let data = await GET(`v1/user/${personalId}/units`);
  return data;
}

export async function fetchUnits() {
  let data = await GET(`${API_UNITS}`);
  return data;
}

export async function fetchTeam(teamID) {
  let data = await GET(API_TEAM + teamID);
  return data;
}

export async function fetchUnitCoworkers(unitID, includeSubUnits) {
  let data = await GET(
    `${API_BASE}units/${unitID}/coworkersforteam?subUnits=${includeSubUnits}`,
  );

  return data;
}

export async function fetchPermissions() {
  let data = await GET(API_PERMISSIONS);
  return data;
}

export async function saveTeam(data) {
  const response = await RAW_POST(API_ADD_TEAM, {}, data);
  const body = getJsonOrDefault(await response.text());

  if (!response.ok || !body?.id) {
    return ERROR_MESSAGE;
  }

  let updatedData = Object.assign({}, data);
  updatedData.teamId = body.id;
  updatedData.id = body.id;

  return updatedData;
}

export async function updateTeam(data) {
  const response = await RAW_PUT(`${API_UPDATE_TEAM}/${data.teamId}`, {}, data);

  if (!response.ok) {
    return ERROR_MESSAGE;
  }

  return getJsonOrDefault(await response.text());
}

export async function deleteTeam(teamID) {
  if (teamID) {
    const deleteResult = await RAW_DELETE(
      `${API_DELETE_TEAM}/${teamID}`,
      {},
      teamID,
    );
    return deleteResult;
  }

  return null;
}

export async function getUserFields() {
  let data = await GET(`${API_GET_USERS_TABLE_FIELDS}`);
  return data;
}
